import richText from "utilities/richText"

export default function TwoColumnList({ blok }) {
  return (
    <div className="content lg:columns-2 gap-8 py-4 prose-h3:break-after-avoid prose-h3:font-bold prose-h3:text-m1 prose-h3:font-secondary prose-h3:pt-0 prose-ul:list-disc prose-ul:pl-4">
      {richText(blok.list)}
    </div>
  )
}
